
export const EXPLICIT_MONTH_DAY_YEAR_MOMENT_FORMAT = 'MMMM Do, YYYY'
export const EXPLICIT_DAY_MONTH_YEAR_MOMENT_FORMAT = 'Do MMMM YYYY'
export const TIME_PORTION_MOMENT_FORMAT = 'LT'
export const DATE_PORTION_MOMENT_FORMAT = 'L'